import type { SearchChatUsers200ContentItem } from './searchChatUsers200ContentItem';

export type SearchChatUsers200 = {
  content: SearchChatUsers200ContentItem[];
  first: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  size: number;
  totalElements: number;
  totalPages: number;
};
